module.exports = __webpack_public_path__ + "img/blog.e176e0ca.png";